import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'

import { generateAthosProvider } from 'libs/athos/fetchers/provider'
import type { AthosFetchOptions } from 'libs/athos/athos.types'

export class AthosSuggest extends AthosFetcher {
  generateURL() {
    return super.generateURL('/suggest')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { query } = options

    this.params.set('language', 'en')
    this.params.set('suggestionCount', 4)
    this.params.set('productCount', 5)

    if (query) this.params.set('q', query)

    super.updateParams()
  }
}

export const AthosSuggestProvider = generateAthosProvider(AthosSuggest, (results) => {
  return {
    ...results,
    items: results.alternatives.map((alternative: any) => ({
      query: alternative.text,
      label: alternative.text
    }))
  }
})
